export const resolveLocationFieldResets = (
  previousState: string,
  nextState: string,
  previousCity: string,
  nextCity: string
): { resetCity: boolean; resetZip: boolean } => {
  const normalizedPrevState = previousState.trim();
  const normalizedNextState = nextState.trim();
  const normalizedPrevCity = previousCity.trim();
  const normalizedNextCity = nextCity.trim();

  if (normalizedPrevState !== normalizedNextState) {
    return { resetCity: true, resetZip: true };
  }

  if (normalizedPrevCity !== normalizedNextCity) {
    return { resetCity: false, resetZip: true };
  }

  return { resetCity: false, resetZip: false };
};

export const validateLocationSelection = (args: {
  state: string;
  city: string;
  zip: string;
  states: readonly string[];
  cities: readonly string[];
  zips: readonly string[];
}): { cityError?: string; zipError?: string } => {
  const state = args.state.trim();
  const city = args.city.trim();
  const zip = args.zip.trim();

  if (!state || !city || !zip) {
    return {};
  }

  const hasState = args.states.length === 0 || args.states.includes(state);
  const hasCity = args.cities.length === 0 || args.cities.includes(city);
  const hasZip = args.zips.length === 0 || args.zips.includes(zip);

  return {
    cityError: hasState && !hasCity ? "Select a valid city for the chosen state." : undefined,
    zipError: hasState && hasCity && !hasZip ? "Select a valid ZIP for the chosen city." : undefined
  };
};
